export enum TransactionActionTypes {
  CHALLENGE_ENROLLMENT = 'enrollment',
  CHALLENGE_ACHIEVEMENT = 'achievement',
  SCAN = 'scan',
  SCAN_DI = 'scan_di',
  SIGN_UP = 'signup',
  COMPLETE_PROFILE = 'complete_profile',
  MANUAL = 'manual',
  ADVOCACY_COUPON = 'consume_advocacy_coupon',
  RECURRENCE_COUPON = 'consume_recurrence_coupon',
  EXPERIENTIAL_COUPON = 'consume_experimental_coupon',
  CUSTOM_COUPON = 'consume_custom_coupon',
  MEDICAL_CENTER = 'medical_center',
}

export enum TransactionEntityTypes {
  REDEEM_PRODUCT = 'redeem',
  QUIZ_TYPEFORM = 'survey',
  CHECKOUT_PRODUCT = 'checkout_product',
  CHECKOUT_LOTTERY = 'checkout_raffle',
  CHECKOUT_DONATION = 'checkout_donation',
  QR = 'qr',
  SIGN_UP = 'signup',
  COMPLETE_PROFILE = 'complete_profile',
  BEAUTY_GUIDE = 'personalized_routine',
  QUIZ_DERMO = 'quiz_dermo',
  PURCHASE = 'purchase',
  MANUAL = 'manual',
  SCAN = 'scan',
  COUPON = 'coupon',
  VIDEO = 'video',
  CHECKOUT_BOOKING_TIMIFY = 'checkout_booking_timify',
  WEBEAT_CHECKOUT_PRODUCT = 'webeat_checkout_product',
  ADVOCACY_REFERRAL = 'advocacy_referral',
}

export enum TransactionStatus {
  PENDING = 'pending',
  VALID = 'valid',
  INVALID = 'invalid',
  FLAGGED = 'flagged',
}
